import { WhmBox, WhmTypography } from "@securitize/reactjs-whm";
import FundHoldingsDownloadButton from "./FundHoldingsDownloadButton";
import FundHoldingsDatePicker from "./FundHoldingsSourceDatePicker";

type Props = {
  tokenId: string;
  onDownload: () => void;
  sourceDate: string | null | undefined;
  onDateChange: (date: string) => void;
};

function FundHoldingsTableToolbar({
  tokenId,
  onDownload,
  sourceDate,
  onDateChange,
}: Props) {
  return (
    <WhmBox
      component="div"
      sx={{
        display: "flex",
        flexDirection: {
          xs: "column",
          sm: "column",
          md: "column",
          lg: "column",
          xl: "row",
        },
        gap: {
          xl: "16px",
        },
        marginBottom: "16px",
        paddingTop: {
          xs: "unset",
          sm: "unset",
          md: "16px",
        },
        marginX: {
          xs: "unset",
          md: "16px",
          lg: "unset",
        },
        justifyContent: {
          xs: "unset",
          sm: "unset",
          md: "unset",
          lg: "unset",
          xl: "space-between",
        },
        justifyItems: {
          xs: "unset",
          sm: "unset",
          md: "center",
        },
      }}
    >
      <WhmBox
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            sm: "column",
            md: "column",
            lg: "column",
            xl: "row",
          },
          justifyContent: {
            xs: "unset",
            sm: "unset",
            md: "flex-start",
            lg: "flex-start",
          },
          gap: {
            xs: "24px",
            sm: "24px",
            md: "24px",
            lg: "8px",
          },
        }}
      >
        <WhmTypography variant="h4" color="text.primary">
          Fund Holdings
        </WhmTypography>
        <FundHoldingsDownloadButton onDownload={onDownload} />
      </WhmBox>
      <WhmBox
        sx={{
          marginTop: {
            xs: "24px",
            sm: "24px",
            md: "24px",
            lg: "24px",
            xl: "unset",
          },
        }}
      >
        <FundHoldingsDatePicker
          tokenId={tokenId}
          value={sourceDate}
          onDateChange={(date) => onDateChange(date)}
        />
      </WhmBox>
    </WhmBox>
  );
}

export default FundHoldingsTableToolbar;
